/**
 * Search Overlay Module
 * 
 * @description
 * <p>Handles Search icon buttons, events and the search overlays</p>
 * <p>On page load, adds click events to the search icon button inside the main nav.</p>
 * <p>Self-initializes when you include this module.</p>
 * 
 * @module search
 *
 * @namespace site.search
 */
( /* @lends module:search */ function(site,$){
	"use strict";
(function($){
	var trace = {push: function() {}},
    dom = {};

	function init() {

		trace = site.utilities && site.utilities.trace ? site.utilities.trace : {push: function() {}};
        
        trace.push("search init");

        dom.site = $('#site');

        // find seach button in top nav

        dom.searchBtn = $('.social-btns').find('.search');
		dom.searchBtn.on('click', function(event) {
            event.preventDefault();
            open();
        });

         set();


    }
    /*
        open and build search overlay
     */
    function open() {
		$(function(){
			$('#search_overlay_input').focus();
		});
        
		var search_text = '';
		if(getParameterByName('keys') != ''){
			var search_text = getParameterByName('keys');
		}
        trace.push("search open");
		var  overlay = '<form action="/search" method="get">';
			overlay += '<div class="search-overlay">';
                overlay += '<div class="close-btn hoverable"></div>';
                overlay += '<div class="search-bar">';
						overlay += '<input  type="search" name="keys" size="30" autocomplete="off" maxlength="128" id="search_overlay_input" class="search" placeholder="Search" aria-label="Search" value="'+search_text+'" />';
						overlay += '<input type="image" src="/img/icons/icon_arrow_go_right.svg" alt="search"/>';
                overlay += '</div>';
            overlay += '</div>';
			overlay += '</form>';

        trace.push("overlay = "+overlay);
        // dom.site.append(overlay);
        var site = document.getElementById('site');
        if (site && typeof site.insertAdjacentHTML === 'function') {
            site.insertAdjacentHTML('beforeend', overlay);
          } else {
            console.error('site is not a valid DOM element');
        }
        
        dom.overlay = $('.search-overlay');

        dom.closeBtn = dom.overlay.find('.close-btn');
        dom.closeBtn.on('click', function() {
            close();
        });

        dom.searchInput = $('#search_input');


        dom.overlay.addClass('active');
         set();
    }
	function getParameterByName(name, url) {
		if (!url) url = window.location.href;
		name = name.replace(/[\[\]]/g, "\\$&");
		var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
		results = regex.exec(url);
		if (!results) return '';
		if (!results[2]) return '';
		return decodeURIComponent(results[2].replace(/\+/g, " "));
	}

    /*
        close search overlay
     */
    function close() {
        dom.site.removeClass('active');   
        setTimeout(function(){ remove(); }, 500); 
    }
    /*
        remove search overlay from the dom
     */
    function remove() {
        dom.overlay.remove();
    }

    /**
     * 
     * @public
     * @function site.search.set
     * @description Removes and replaces the placeholder text in the input
     * @example
     * {@lang JavaScript}
     * site.search.set();
     */

    function set(){
        $("input[type=search]").focus(function() {
            trace.push('search');
            $(this).attr("placeholder","");
        });

        $("input[type=search]").blur(function() {
            trace.push('search');
            var value = $(this).val();
            if(value == "") $(this).attr("placeholder","Search");
        });
    }

	// Public API definitions
	site.search = {
        set: set
	};


	$(function(){
		init();
	});
	})(jQuery);
})(window.site=window.site || {}, jQuery);
